import { Box, Stack, Typography } from "@mui/material";
import { ButtonComponent } from "../components/form";

const BannerView = ({
    title, 
    description, 
    ml=0,
    action=null,
    actionText=""
}) => {
    return (
        <>
            <Box
                display="flex"
                alignItems="end"
                sx={{ 
                    backgroundImage: `linear-gradient(0deg, rgba(255, 255, 255, 0.2) 20%, rgba(255, 133, 47, 0.9)), url(/images/login-banner.png)`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    position: 'fixed',
                    height: '100vh',
                    width: '33%',
                    display: {xs: 'none', lg: 'flex'},
                    ml: ml
                }}
            >
                <Stack
                    sx={{
                        pb: 10,
                        pl: 7,
                        pr: 7
                    }}
                >
                    {/* Title */}
                    <Typography
                        textAlign='center'
                        sx={{
                            fontWeight: 800,
                            fontSize: 40,
                            letterSpacing: 0.36,
                            lineHeight: 1.25,
                            color: 'white',
                            mb: 4
                        }}
                    >
                        {title}
                    </Typography>

                    {/* Description */}
                    <Typography
                        textAlign='center'
                        sx={{
                            fontWeight: 400,
                            fontSize: 20,
                            letterSpacing: 0.5,
                            lineHeight: 1,
                            color: 'white'
                        }}
                    >
                        {description}
                    </Typography>

                    {
                        action && actionText.trim().length > 0
                        ?
                        <ButtonComponent 
                            label={actionText}
                            onClick={action}
                            sx={{
                                borderRadius: 50,
                                mx: 6
                            }}
                        />
                        :
                        <></>
                    }
                </Stack>
            </Box>
        </>
    );
}

export default BannerView;